import * as Yup from 'yup';
import PropTypes from 'prop-types';
// import { useSnackbar } from 'notistack';
// import { useNavigate } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { styled } from '@mui/material/styles';
import { DatePicker, LoadingButton, LocalizationProvider } from '@mui/lab';
import {
  Card,
  Grid,
  Stack,
  Radio,
  TextField,
  Typography,
  RadioGroup,
  InputAdornment,
  FormHelperText,
  FormControlLabel,
  Alert,
  Divider,
  LinearProgress,
  Button
} from '@mui/material';
import { firestore, storage as st } from '../../../../../contexts/FirebaseContext';
// utils

//
// import { QuillEditor } from '../../editor';
import { UploadSingleFile } from '../../../../upload';
import { fData, fPercent } from '../../../../../utils/formatNumber';
// import { getURLFile } from '../../../utils/storagef';
import { Box } from '@mui/system';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import useAuth from '../../../../../hooks/useAuth';
import { createNotificationsByRole } from '../../../../../utils/notifications';
import { sendNotificationByRoleAPI } from '../../../../../_apis_/notifications';
import useAuthUsers from '../../../../../hooks/useAuthUsers';
import useAgregarFondos from '../../../../../hooks/agregarFondos/useAgregarFondos';
import { useSnackbar } from 'notistack';

// ----------------------------------------------------------------------

const DEPOSIT_PLACE = ['Transferencia bancaria', 'Deposito ventanilla'];

// const CATEGORY_SERVICE = ['Pagos de servicio', 'Paqueteria', 'Pago de recargas'];
const CATEGORY_SERVICE = [
  { id: 'SERVICIO', label: 'Pagos de servicio' },
  { id: 'PAQUETERIA', label: 'Paqueteria' },
  { id: 'RECARGA', label: 'Pago de recargas' }
];

const LabelStyle = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(1)
}));

// ----------------------------------------------------------------------

ReportRecarga.propTypes = {
  handleClose: PropTypes.func,
  currentProduct: PropTypes.object
};

export default function ReportRecarga({ currentProduct, handleClose, user }) {
  // const navigate = useNavigate();
  // const { enqueueSnackbar } = useSnackbar();
  const [file, setFile] = useState({ preview: '', file: null });
  const [pF, setPF] = useState(0);
  const [pData, setPData] = useState('');
  const [success, setSuccess] = useState(false);

  const [userCajeroId, setUserCajeroId] = useState('');

  console.log('este essssssssssssssssss-----', user);

  const { currentUser } = useAuthUsers();
  const { verifyReporteFolio } = useAgregarFondos();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (user.id === currentUser?.hostUser) {
      setUserCajeroId(currentUser.id);
    }
  }, [currentUser?.hostUser, currentUser.id, user.assignedUsers, user.id]);

  const NewProductSchema = Yup.object().shape({
    folio: Yup.string().required('El folio es requerido'),
    // description: Yup.string().required('Description is required'),
    // images: Yup.array().min(1, 'Ingrese la imagen del recibo'),
    // price: Yup.number().required('Price is required')
    amount: Yup.number().required('Ingrese el monto'),
    date: Yup.date().required('Ingrese la fecha')
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      folio: currentProduct?.folio || '',
      date: currentProduct?.date || '',
      //   description: currentProduct?.description || '',
      image: null,
      //   code: currentProduct?.code || '',
      //   sku: currentProduct?.sku || '',
      //   price: currentProduct?.price || '',
      //   priceSale: currentProduct?.priceSale || '',
      //   tags: currentProduct?.tags || [TAGS_OPTION[0]],
      //   inStock: Boolean(currentProduct?.inventoryType !== 'out_of_stock'),
      //   taxes: true,
      deposit_place: DEPOSIT_PLACE[0],
      category_service: CATEGORY_SERVICE[0].label,

      //
      amount: currentProduct?.amount || ''
    },
    validationSchema: NewProductSchema,
    onSubmit: async (values) => {
      const verifyFolio = await verifyReporteFolio(values.folio);
      if (verifyFolio) {
        // console.log('se guarda datos');
        const newDoc = values;
        // console.log(newDoc);
        newDoc.category_service_id = CATEGORY_SERVICE.find((cat) => cat.label === newDoc.category_service).id;

        //   setFile({ preview: values.images[0].preview, file: values.images[0] });

        const urlImg = await uploadMedia();
        newDoc.image = urlImg;
        // console.log(newDoc);
        newDoc.status = 'PENDIENTE';
        newDoc.user_id = user.id;
        newDoc.authorized_at = null;
        newDoc.created_at = new Date();
        newDoc.updated_at = new Date();
        newDoc.userDispalyName = user.displayName;
        newDoc.cajeroId = userCajeroId;
        // newDoc.date = new Date();
        // console.log(newDoc);
        await firestore
          .collection('payment_reports')
          .add(newDoc)
          .then(() => {
            // console.log('creado');
            setSuccess(true);
            handleClose();
            ['almighty', 'administrativo'].forEach((role) => {
              createNotificationsByRole(
                role,
                'Solicitud de recarga',
                `${user.displayName} ha solicitado una recarga`,
                null,
                'info',
                '/dashboard/cotizaciones/administracion'
              );
              sendNotificationByRoleAPI(role, {
                title: 'Solicitud de Recarga',
                message: `${user.displayName} ha solicitado una recarga`
              });
            });
          });
      } else {
        enqueueSnackbar('El numero de folio ya existe, ingrese otro', { variant: 'error' });
      }
    }
  });
  //   console.log(file);

  const uploadMedia = useCallback(async () => {
    const refF = st.ref().child(`payment_report/${file.file.name}`);

    return new Promise((resolve) => {
      if (file.file !== null) {
        refF.put(file.file).on('next', (snapshot) => {
          const percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setPF(percent);
          setPData(`${fData(snapshot.bytesTransferred)} / ${fData(snapshot.totalBytes)}  (${fPercent(percent)})`);
          if (percent === 100) {
            setTimeout(() => {
              refF.getDownloadURL().then((url) => {
                resolve(url);
              });
            }, 1500);
          }
        });
      } else {
        resolve(null);
      }
    });
  }, [file]);

  const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik;

  /* const handleDrop = useCallback(
    (acceptedFiles) => {
      setFieldValue(
        'images',
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file)
          })
        )
      );
    },
    [setFieldValue]
  ); */

  const handleRemove = (file) => {
    const filteredItems = values.images.filter((_file) => _file !== file);
    setFieldValue('images', filteredItems);
  };

  return (
    <FormikProvider value={formik}>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <Box padding="15px">
          <Alert severity="info">
            Todo abono solicitado de lunes a jueves antes de las 18:00 hrs se vera reflejado hasta el día hábil
            posterior. Los abonos solicitados en viernes y días festivos se verán reflejados hasta el día siguiente
            hábil posterior
          </Alert>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Card sx={{ p: 3 }}>
              <Stack spacing={3}>
                <TextField
                  fullWidth
                  label="Folio"
                  {...getFieldProps('folio')}
                  error={Boolean(touched.folio && errors.folio)}
                  helperText={touched.folio && errors.folio}
                />

                <TextField
                  fullWidth
                  placeholder="0.00"
                  label="Monto de recarga"
                  {...getFieldProps('amount')}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    type: 'number'
                  }}
                  error={Boolean(touched.amount && errors.amount)}
                  helperText={touched.amount && errors.amount}
                />
                <Divider />
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Fecha de deposito"
                    id="date"
                    name="date"
                    // {...getFieldProps('date')}
                    value={values.date}
                    onChange={(newValue) => {
                      setFieldValue('date', newValue);
                    }}
                    error={Boolean(touched.date && errors.date)}
                    renderInput={(params) => <TextField {...params} />}
                  />
                  {errors.date && (
                    <Typography marginTop="0px" color="error" fontSize="12px">
                      Ingrese la fecha
                    </Typography>
                  )}
                </LocalizationProvider>

                {/* <div>
                  <LabelStyle>Fecha del deposito</LabelStyle>
                  <Input {...getFieldProps('date')} type="date" error={Boolean(touched.date && errors.date)} />
                  {errors.date && (
                    <Typography color="error" fontSize="12px">
                      Ingrese la fecha
                    </Typography>
                  )}
                </div> */}

                <div>
                  <LabelStyle>Lugar de depósito</LabelStyle>
                  <RadioGroup {...getFieldProps('deposit_place')} row>
                    <Stack spacing={1} direction="row">
                      {DEPOSIT_PLACE.map((deposit_place) => (
                        <FormControlLabel
                          key={deposit_place}
                          value={deposit_place}
                          control={<Radio />}
                          label={deposit_place}
                        />
                      ))}
                    </Stack>
                  </RadioGroup>
                </div>

                <div>
                  <LabelStyle>Tipo de recarga</LabelStyle>
                  <RadioGroup {...getFieldProps('category_service')} row>
                    <Stack spacing={1} direction="row">
                      {CATEGORY_SERVICE.map((category) => (
                        <FormControlLabel
                          key={category.id}
                          value={category.label}
                          control={<Radio />}
                          label={category.label}
                        />
                      ))}
                    </Stack>
                  </RadioGroup>
                </div>

                <Divider />

                <div>
                  <LabelStyle>Recibo de pago</LabelStyle>
                  <UploadSingleFile
                    showPreview
                    maxSize={3145728}
                    accept="image/*"
                    file={file.preview}
                    onDrop={(filec) => {
                      setPData(`${fData(filec[0].size)}`);
                      setFile({
                        file: filec[0],
                        preview: URL.createObjectURL(filec[0])
                      });
                    }}
                    onRemove={handleRemove}
                    showBtn={false}
                    // onRemoveAll={handleRemoveAll}
                    error={Boolean(touched.images && errors.images)}
                  />
                  <LinearProgress variant="determinate" value={pF} />
                  {pData}
                  {touched.images && errors.images && (
                    <FormHelperText error sx={{ px: 2 }}>
                      {touched.images && errors.images}
                    </FormHelperText>
                  )}
                </div>
              </Stack>
              {!success && (
                <LoadingButton
                  sx={{ marginTop: '15px' }}
                  type="submit"
                  fullWidth
                  variant="contained"
                  size="large"
                  loading={isSubmitting}
                >
                  Enviar reporte
                </LoadingButton>
              )}
              {success && (
                <Button
                  sx={{ marginTop: '15px', textTransform: 'initial' }}
                  fullWidth
                  onClick={() => setSuccess(false)}
                >
                  Reporte enviado, hacer otro reporte
                </Button>
              )}
            </Card>
          </Grid>

          {/* <Grid item xs={12} md={4}>
            <Stack spacing={3}>
              <Card sx={{ p: 3 }}>
                <FormControlLabel
                  control={<Switch {...getFieldProps('inStock')} checked={values.inStock} />}
                  label="In stock"
                  sx={{ mb: 2 }}
                />

                <Stack spacing={3}>
                  <TextField fullWidth label="Product Code" {...getFieldProps('code')} />
                  <TextField fullWidth label="Product SKU" {...getFieldProps('sku')} />

                  <div>
                    <LabelStyle>Gender</LabelStyle>
                    <RadioGroup {...getFieldProps('gender')} row>
                      <Stack spacing={1} direction="row">
                        {GENDER_OPTION.map((gender) => (
                          <FormControlLabel key={gender} value={gender} control={<Radio />} label={gender} />
                        ))}
                      </Stack>
                    </RadioGroup>
                  </div>

                  <FormControl fullWidth>
                    <InputLabel>Category</InputLabel>
                    <Select label="Category" native {...getFieldProps('category')} value={values.category}>
                      {CATEGORY_OPTION.map((category) => (
                        <optgroup key={category.group} label={category.group}>
                          {category.classify.map((classify) => (
                            <option key={classify} value={classify}>
                              {classify}
                            </option>
                          ))}
                        </optgroup>
                      ))}
                    </Select>
                  </FormControl>
                  <Autocomplete
                    multiple
                    freeSolo
                    value={values.tags}
                    onChange={(event, newValue) => {
                      setFieldValue('tags', newValue);
                    }}
                    options={TAGS_OPTION.map((option) => option)}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip {...getTagProps({ index })} key={option} size="small" label={option} />
                      ))
                    }
                    renderInput={(params) => <TextField label="Tags" {...params} />}
                  />
                </Stack>
              </Card>

              <Card sx={{ p: 3 }}>
                <Stack spacing={3}>
                  <TextField
                    fullWidth
                    placeholder="0.00"
                    label="Regular Price"
                    {...getFieldProps('price')}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                      type: 'number'
                    }}
                    error={Boolean(touched.price && errors.price)}
                    helperText={touched.price && errors.price}
                  />

                  <TextField
                    fullWidth
                    placeholder="0.00"
                    label="Sale Price"
                    {...getFieldProps('priceSale')}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                      type: 'number'
                    }}
                  />
                </Stack>

                <FormControlLabel
                  control={<Switch {...getFieldProps('taxes')} checked={values.taxes} />}
                  label="Price includes taxes"
                  sx={{ mt: 2 }}
                />
              </Card>

              <LoadingButton type="submit" fullWidth variant="contained" size="large" loading={isSubmitting}>
                {!isEdit ? 'Create Product' : 'Save Changes'}
              </LoadingButton>
            </Stack>
          </Grid> */}
        </Grid>
      </Form>
    </FormikProvider>
  );
}
